import React from 'react';
import RankBox from './RankBox';
import { GDPIndexChart } from './charts/EconomyCharts';
import NortheastGDPMap from './charts/NortheastGDPMap';
import { gdp , employment } from './api/rankBoxes';
import { gdpData } from './api/economyData';

const EconomyView = () => {
  return (
    <>
      <div className="flex flex-wrap justify-center mb-8">
        <RankBox
          title="YoY GDP Growth"
          value={gdp?.value || 0}
          type="percent"
          rank={gdp?.rank}
          trend={gdp?.trend}
        />
        <RankBox
          title="Employment Growth (1Yr)"
          value={employment?.value || 0}
          type="percent"
          rank={employment?.rank}
          trend={employment?.trend}
        />
      </div>
      
      {/* Northeast GDP Map Section */}
      <div className="bg-white p-4 rounded-lg shadow mb-8">
        <h2 className="text-xl font-semibold mb-4">Northeast GDP Map</h2>
        <NortheastGDPMap />

        {/* GDP Index Section */}
        <div className="bg-white p-4 rounded-lg shadow mb-8">
          <h2 className="text-xl font-semibold mb-4">GDP Index</h2>
          <GDPIndexChart data={gdpData} />
        </div>
      </div>
    </>
  );
};

export default EconomyView;